import api from "./client";

export default {
    getVerificationData(data = {status: 'pending'}) {
        return api.post('/admin/getVerificationData', data);
    },
    verify(data) {
        return api.post('/admin/verify', data);
    },
    getOverView() {
        return api.get('/admin/getOverview');
    },
    getUserData(id) {
        return api.get('/admin/getUserData/' + id);
    },
    toggleFlag(data) {
        return api.post('/admin/flag', data);
    },
    search(q, page = 1) {
        return api.post('/admin/search?page=' + page, {q: q});
    },
    getVideos(page) {
        return api.get('/admin/getVideos?page=' + page);
    },
    getImages(page) {
        return api.get('/admin/getAllImages?page=' + page);
    },
    getProfileImages(page) {
        return api.get('/admin/getProfileImages?page=' + page);
    },
    deleteMedia(id){
        return api.get('/admin/deleteMedia/' + id);
    },
    verifyVideo(user_id,data) {
        return api.post('/admin/verifyVideo/' + user_id,data);
    },
    warn(user_id) {
        return api.get('/admin/warn/' + user_id);
    },
    suspend(user_id) {
        return api.get('/admin/suspend/' + user_id);
    },
    getAutoTopup(page = 1) {
        return api.get('/admin/getAutoTopup?page=' + page);
    }
}

